export default {
  state: {
    dateTimePicker: {
      show: false,
      forPickupDate: false
    }
  },
  mutations: {
    showDateTimePicker (state) { state.dateTimePicker.show = true },
    hideDateTimePicker (state) { state.dateTimePicker.show = false },
    setForPickupDate (state, value) { state.dateTimePicker.forPickupDate = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/datetime-picker.js